module.exports = __webpack_public_path__ + "static/media/phone.6fbeba51.svg";